module.exports = "data:image/gif;base64,R0lGODlhEAAQAKIAAAAAAP///wER3Sw/8P///wAAAAAAAAAAACH5BAEAAAQALAAAAAAQABAAAAMkSLrc/g8AJSEVcgxZHdDgBn3hZJHdKVqMyS7uS8kwXduxrTsJADs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/marked.gif
// module id = C71D
// module chunks = 1